import {
    Navigate, Outlet,
} from 'react-router-dom'

import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    FinanceDomains,
} from 'app/enums/domain.enums'
import FxRates from './FxRates'
import Invoices from './Invoices'
import LongTermInvoicesRoutes from './LongTermInvoices'

export default [
    {
        path: `${FinanceDomains.Invoices}/${CommonRoutes.Asterisk}`,
        element: <Invoices />,
    },
    {
        path: `${FinanceDomains.FxRates}/${CommonRoutes.Asterisk}`,
        element: <FxRates />,
    },
    {
        path: FinanceDomains.LongTermInvoices,
        element: <Outlet />,
        children: LongTermInvoicesRoutes,
    },
    {
        path: CommonRoutes.Asterisk,
        element: <Navigate
            to={FinanceDomains.Invoices}
            replace
        />,
    },
]
